import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M21.426 2.35l.032.03a.756.756 0 0 1 .118.108l-.035-.035c.366.364.497.903.339 1.398l-5.453 16.74a1.988 1.988 0 0 1-1.935 1.359 1.996 1.996 0 0 1-1.873-1.48l-1.764-7.329-7.322-1.756-.028-.007a1.99 1.99 0 0 1-.087-3.803L20.144 2.12a1.376 1.376 0 0 1 1.282.23zm-1.56 2.84l-7.562 7.562 1.767 7.341a.488.488 0 0 0 .932.028l4.863-14.93zm-1.068-1.054L3.889 9a.49.49 0 0 0 .012.932l7.342 1.76 7.555-7.555z' />
  </svg>
);
